import axios from "../../axios";

export const getRecentAnalyzedReports = async ({
  page = 0,
  pageSize = 25,
  order = "desc",
  sortBy = "lastUpdationOn",
  reportSearch = "",
}) => {
  try {
    const response = await axios.get(
      `/internal/api/report/all?page=${page}&size=${pageSize}&order=${order}&sortBy=${sortBy}&reportSearch=${reportSearch}`
    );
    return response.data;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export const downloadReport = async (accountId, reportId, reportDetails) => {
  try {

    const url = accountId === "all"
      ? `/internal/api/report/download-report?reportId=${reportId}`
      : `/internal/api/report/download-report?accountId=${accountId}`;

    const response = await axios.get(url, {
      responseType: 'blob',
      ...(accountId !== "all" && { data: { report_id: reportId } }),
    });

    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = downloadUrl;

    console.log("bank name", reportDetails.reportAccounts[0].account.bankName)
    link.setAttribute(
      'download',
      `${reportDetails.report?.reportName}_${accountId === "all"
        ? 'All Bank Accounts'
        : `${reportDetails.reportAccounts?.[0]?.account?.bankName || 'Unknown Bank'}${reportDetails.reportAccounts?.[0]?.account?.accountNumber || 'Unknown Account'}${reportDetails.reportAccounts?.[0]?.account?.accountTypeName?.split(' ')[0] || 'Unknown'}`
      }.xlsx`
    );

    console.log("fileeeeee", reportDetails.report.reportName
      , 'download', `report_${accountId === "all" ? 'All Bank Accounts' : accountId}_${reportId}.xlsx`)
    // report_all_accounts_PR9993372305586105.xlsx
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  } catch (error) {
    console.error('Error downloading the report:', error);
  }
};